// removed by extract-text-webpack-plugin
module.exports = {"error__code":"Page404-module__error__code___2gevp","error__message":"Page404-module__error__message___3FisI"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Page404/Page404.module.css
// module id = 637
// module chunks = 0